import { Cadastro } from 'app/shared/interfaces/cadastro';
import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { LayoutService } from 'app/shared/services/layout.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { JwtAuthService } from 'app/shared/services/auth/jwt-auth.service';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { CadastroService } from 'app/shared/services/cadastro.service';
import { CadastroUtilsService } from 'app/shared/services/cadastro-utils.service';

@Component({
  selector: 'app-cadastro-web-popup',
  templateUrl: './cadastro-web-popup.component.html',
  styleUrls: ['./cadastro-web-popup.component.scss']
})
export class CadastroWebPopupComponent implements OnInit {

  webForm: FormGroup;
  cadastro: Cadastro;
  layoutConf: any;

  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CadastroWebPopupComponent>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private layout: LayoutService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private snack: MatSnackBar,
    private authService: JwtAuthService,
    private loader: AppLoaderService,
    private cadastroService: CadastroService,
    private cadastroUtilsService : CadastroUtilsService
  ) { }

  ngOnInit(): void {
    this.layoutConf = this.layout.layoutConf;
    this.cadastro = this.data.payload;
    console.log(`cadastro: ${this.cadastro.codigo} - ${this.cadastro.razaoSocial}`);

    this.buildWebForm(this.cadastro);

  }

  buildWebForm(cad: Cadastro) {
    this.webForm =   this.cadastroUtilsService.buildForm(this.fb, cad);
    // this.fb.group({
    //   id:            [cad.id],
    //   lojaOnline:    [cad?.lojaOnline    || false],
    //   app:           [cad?.app           || false],
    //   empresaRemota: [cad?.empresaRemota || false],
    //   urlApi:        [cad?.urlApi,      [Validators.required]],
    //   urlFotoLoja:   [cad?.urlFotoLoja, [Validators.required]],
    //   urlLogo:       [cad?.urlLogo,     [Validators.required]],
    // });
  }


  close() {
    this.dialogRef.close();
  }

  save() {
    if (this.webForm.invalid) {
      this.snack.open('Campos obrigatórios não preenchidos, verifique!', 'ERRO', { duration: 6500 });
      return;
    }
    console.log(this.webForm.value);
    this.cadastroService.saveOrUpdate(this.webForm.value).subscribe(
      val => {
        console.log(val);
        this.confirmService.confirm({
          title: 'SALVAR',
          message: 'OK, Configurações Web Salvas com Sucesso!', error: false
        });
      },
      err => {
        this.confirmService.confirm({
          title: 'ERRO AO SALVAR CONFIGURAÇÕES, VERIFIQUE',
          message: err.error.status, error: true
        })
      });
    return;
  }

}
